import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import accountSlice from './slices/account.slice';
import platformSlice from './slices/platform.slice';
import urbanCenterSlice from './slices/urban-center.slice';
import addingWasteTreatmentSlice from '../../features/logistics/store/adding-waste-treatment.slice';
import addressSlice from './slices/address.slice';
import contactSlice from './slices/contact.slice';
import yearSlice from './slices/year.slice';
import saleSlice from './slices/sale.slice';
import clientContactSlice from './slices/client-contact.slice';
import clientContactPersonSlice from './slices/client-contact-person.slice';
import contactAddressSlice from './slices/contact-addresses.slice';
// Feature reducers
import { catalogPriceSlice, optionSlice, productSlice, productTypeRegulSlice } from 'features/products/store';
import priceSlices from 'features/products/store/price.slice';
import regionSlices from 'features/regions/store';
import regionProductTypeSlice from 'features/regions/store/region-product-type.slice';
import serviceProviderSlice from 'features/service-providers/store/service-provider.slice';
import wasteCenterTypeSlice from 'features/service-providers/store/waste-center-type.slice';
import searchPrice from './slices/search-price.slice';
import documentReducer from 'features/documents/store/document.slice';
import providerInvoiceSlice from './slices/provider-invoice.slices';
import renouvellementReducer from 'features/renouvellement/store/renouvellement.slice';

const store = configureStore({
  reducer: {
    account: accountSlice,
    product: productSlice,
    productTypeRegul: productTypeRegulSlice,
    option: optionSlice,
    price: priceSlices,
    region: regionSlices,
    platform: platformSlice,
    urbanCenter: urbanCenterSlice,
    regionProductType: regionProductTypeSlice,
    catalogPrice: catalogPriceSlice,
    serviceProvider: serviceProviderSlice,
    contact: contactSlice,
    year: yearSlice,
    sale: saleSlice,
    clientContact: clientContactSlice,
    clientContactPerson: clientContactPersonSlice,
    document: documentReducer,
    address: addressSlice,
    contactAddress: contactAddressSlice,
    searchPrice: searchPrice,
    wasteCenterType: wasteCenterTypeSlice,
    addingWasteTreatment: addingWasteTreatmentSlice,
    providerInvoice: providerInvoiceSlice,
    renouvellement: renouvellementReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
